// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PieChart__chartContainer__l9ww6 {\n  max-width: 120px;\n  max-height: 120px;\n}\n\n.PieChart__chartContainerSmall__SYHG1 {\n  max-width: 90px;\n  max-height: 90px;\n}\n", "",{"version":3,"sources":["webpack://./../client/components/Instructor/PieChart/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".chartContainer {\n  max-width: 120px;\n  max-height: 120px;\n}\n\n.chartContainerSmall {\n  max-width: 90px;\n  max-height: 90px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": "PieChart__chartContainer__l9ww6",
	"chartContainerSmall": "PieChart__chartContainerSmall__SYHG1"
};
export default ___CSS_LOADER_EXPORT___;
